import React from 'react'
import {
  ArrayInputContentProps,
  useKArrayInput,
} from 'services/hooks/useKArrayInput'
import { getById } from 'services/utils'
import useFacets from 'ui-shared/Facets/BaseComponents/useFacets'
import LocalizedSelectInput from 'ui-shared/LocalizedFields/LocalizedSelectInput'
import { PricingFacet } from 'services/api/entities/catalog/facets'
import { OptionedProductPresetFieldsProps } from './OptionedProductPresetFields'
import RatioMultiplier from './RatioMultiplier'
import QuantityMultiplier from './QuantityMultiplier'
import { BaseProductPreset } from 'services/api/entities/catalog/packages/common'
import { Upselling } from 'services/api/entities/catalog/upselling/types/internal/upselling-models'

type Props = ArrayInputContentProps &
  Pick<OptionedProductPresetFieldsProps, 'selectedProduct'>

const UpsellingPresetSelector: React.FC<Props> = ({
  source,
  selectedProduct,
}) => {
  const { kGetSource, scopedFormData: upsellingPreset } =
    useKArrayInput<BaseProductPreset>(source!)

  const pricingFacets = useFacets<PricingFacet>('pricing')

  if (!selectedProduct) return null

  const upsellingPricing =
    getById<Upselling>(selectedProduct.upsellingItemsFull, upsellingPreset?.id)
      ?.pricingFacet ?? undefined

  const pricingType = getById<PricingFacet>(
    pricingFacets,
    upsellingPricing
  )?.pricingType

  return (
    <>
      <LocalizedSelectInput
        label="form.fields.upsellingItems"
        choices={selectedProduct?.upsellingItemsFull}
        source={kGetSource('id')}
        fullWidth
      />

      {pricingType === 'perItem' ? (
        <RatioMultiplier getSource={kGetSource} />
      ) : (
        <QuantityMultiplier disabled getSource={kGetSource} />
      )}
    </>
  )
}

export default UpsellingPresetSelector
